<template>
  <div class="mb-4 col-sm-12 col-lg-6">
    <div class="faq-heading d-flex justify-content-between pl-lg-2">
      <div class="col-11 d-flex align-items-center pl-0 pr-0 pl-lg-2">
        <button class="bg-transparent" @click="toggle">
          <mdicon
            :id="'dropdown-button' + id"
            :name="isOpen ? 'minus' : 'plus'"
            size="14"
            :style="isOpen ? { transform: 'rotate(180deg)' } : {}"
            class="dropdown-green"
          />
        </button>
        <h2 class="pointer faq-title mb-0 col-11" @click="toggle">
          {{ question }}
        </h2>
      </div>
      <span class="d-flex mt-2">
        <span @click="openDeleteModal">
          <b-icon v-if="authenticated && isStaff" icon="trash" scale="1.5em" class="pointer text-danger mr-3" />
        </span>
        <span @click="editQuestion">
          <b-icon v-if="authenticated && isStaff" icon="pencil" scale="1.5em" class="pointer text-success" />
        </span>
      </span>
    </div>
    <div v-if="isOpen" class="pt-4 pr-5">
      <div class="mb-4 pl-5">
        <div>
          <div>
            <div>
              <span class="small">{{ answer }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { openModal } from '@/services/Modal'
import { useAccountStore } from '@/store/account'
import { useFaqStore } from '@/store/faq'
import { FAQ_EDIT } from '@/types/router'
import BIcon from '@/views/Components/Elements/Icons/BIcon.vue'

export default defineComponent({
  name: 'QuestionAnswer',
  components: { BIcon },
  props: {
    id: {
      type: Number,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isOpen = ref(false)
    const accountStore = useAccountStore()
    const faqStore = useFaqStore()
    const router = useRouter()

    const isStaff = computed(() => accountStore.isStaff)
    const authenticated = computed(() => accountStore.userId)

    const toggle = () => {
      isOpen.value = !isOpen.value
    }

    const openDeleteModal = () => {
      openModal('confirmWrap', {
        title: 'Are you sure you want to delete this questions?',
        message: 'This action cannot be undone.',
        onConfirm: () => {
          faqStore.deleteQuestion(String(props.id))
        },
      })
    }

    const editQuestion = () => {
      router.push({
        name: FAQ_EDIT,
        params: {
          id: props.id,
        },
      })
    }

    return {
      isOpen,
      isStaff,
      authenticated,
      toggle,
      openDeleteModal,
      editQuestion,
    }
  },
})
</script>
